module.exports = __webpack_public_path__ + "f8e5a9deece15ea985be547b5bcb83ba.svg";